/* @flow */
import React, { useEffect, useState } from "react";
import { Button, Form, Message, Modal } from "semantic-ui-react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  clearError,
  createPaymentReturn as settlementCreatePaymentReturn,
} from "../../../redux/modules/charge";
import { getEstate } from "../../../redux/modules/estates";
import { FormdataManager } from "../../../components/common/formdata";
import { ErrorWrap } from "../../../helpers/error";
import { withRouter } from "react-router";
import { t } from "../../../constant/translations";

type Props = {
  estate: Object,
  charge: Object,
  loading: boolean,
  error?: ErrorWrap,
  triggerText?: string,
};

export const ReturnCharge = (props: Props) => {
  const [formData, setFormData] = useState({});
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setFormData({
      estate: props.estate.id,
      description: "",
      charge_id: props.charge.id,
    });
  }, [props.estate.id, props.charge.id]);

  useEffect(() => {
    if (props.loading && !props.error?.exists()) {
      setModalOpen(false);
    }
  }, [props.loading, props.error]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!props.loading) {
      props.submit(formData);
    }
  };

  const { estate, loading, error, media, charge } = props;
  const form = new FormdataManager(formData, setFormData);
  form.withError(error);

  return (
    <Modal
      onOpen={() => setModalOpen(true)}
      onClose={() => {
        if (!loading) {
          setModalOpen(false);
          props.clearError();
        }
      }}
      open={modalOpen}
      trigger={
        <Button
          basic
          size={"tiny"}
          icon={"undo"}
          disabled={charge.amount_left === charge.amount}
        />
      }
      closeIcon={true}
    >
      <Modal.Header>
        {t("charge.return_obligation")} {estate.name} {t("labels.from")}{" "}
        {parseFloat(charge.amount - charge.amount_left).toFixed(2)}{" "}
        {t(`resources.currency.${props.selectedCurrency.toLowerCase()}`)}{" "}
        {t("labels.in")} {t("charge.balance")}
      </Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <Form onSubmit={handleSubmit} error={error?.exists()}>
            <Form.Field
              control="textarea"
              label={t("charge.cause")}
              rows={3}
              {...form.getAttributes("description")}
            />
            <Message
              error
              content={error?.exists() ? error.getGlobal() : t("error.savng")}
            />
            <Button type="submit" fluid size="large" positive loading={loading}>
              {t("charge.return_to_balance")}
            </Button>
          </Form>
        </Modal.Description>
      </Modal.Content>
    </Modal>
  );
};

function mapStateToProps(state) {
  return {
    loading: state.charge.pending,
    error: ErrorWrap.fromError(state.charge.error),
    selectedCurrency: state.currency.selectedCurrency,
  };
}

const buildPaymentReturnAction = ({ history }) => (formData) => {
  return (dispatch) => {
    return dispatch(settlementCreatePaymentReturn(formData)).then(
      (resp) => !resp.error && dispatch(getEstate(formData.estate))
    );
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const submit = buildPaymentReturnAction(ownProps);
  return bindActionCreators({ submit, clearError }, dispatch);
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReturnCharge)
);
